<template>
  <div>
    <section class="contact-us">
      <div class="row">
        <div class="col-sm-12 contact-titr">
          <h6>تماس با ما</h6>
        </div>
        <div class="col-sm-6 contact-right">
          <div class="col-sm-12 d-flex pb-5">
            <div class="d-flex contact-right-icon">
              <i class="icon-warehouse"></i>
            </div>
            <div class="d-flex contact-right-all">
              <div class="d-flex contact-right-p">
                <p>پشتیبانی تامین کنندگان</p>
              </div>
              <div class="d-flex contact-right-link">
                <a href>
                  <i class="icon-telegram1"></i>
                  <span>Teachersupport</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-12 d-flex pb-5">
            <div class="d-flex contact-right-icon">
              <i class="icon-teacher"></i>
            </div>
            <div class="d-flex contact-right-all">
              <div class="d-flex contact-right-p">
                <p>پشتیبانی معلمین</p>
              </div>
              <div class="d-flex contact-right-link">
                <a href>
                  <i class="icon-telegram1"></i>
                  <span>Suppliersupport</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-12 d-flex pb-5">
            
            <div class="d-flex contact-right-all pr-5 mr-4">
              <div class="d-flex contact-right-p pb-2">
                <p>شماره تماس  </p>
              </div>
              <div class="d-flex contact-right-link">
                <a href>
                  <i class="icon-phone"></i>
                  <span>٠٩٢١٢١٩١٦٥٧</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6"></div>
      </div>
      <div class="contact-pic">
                
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Contact",
};
</script>